export default __webpack_public_path__ + "static/lion-studios-b1162277b613fd9cb3d77b5b76d9ed29.svg";